import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
import { trackPixelEvent } from '../utils/metaPixel';
import { CHECKOUT_URL } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState<boolean>(false);
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-218" data-mp="3gkfhrd7jqltk">
      {visible ? <motion.div initial={{
      y: 90
    }} animate={{
      y: 0
    }} exit={{
      y: 90
    }} transition={{
      duration: 0.28,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold-500/25 bg-ink-950/95 backdrop-blur" data-id="element-219" data-mp="3gje3z0z5bl85">
          <div className="mx-auto flex max-w-4xl items-center justify-between gap-4 px-4 py-3" data-id="element-220" data-mp="gztog58fxgfc">
            <div className="min-w-0" data-id="element-221" data-mp="73t2gu8zey5k">
              <p className="truncate text-xs font-semibold uppercase tracking-wide text-cream/60" data-id="element-222" data-mp="27b206koplz1">
                Precio de lanzamiento
              </p>
              <p className="flex items-baseline gap-2" data-id="element-223" data-mp="gx06aao2q63j">
                <span className="font-display text-xl text-gold-500" data-id="element-224" data-mp="c4p3n01y867a">$19.990</span>
                <span className="text-xs text-cream/40 line-through" data-id="element-225" data-mp="pw3shnijf1m9">$89.000</span>
                <span className="hidden text-xs tabular-nums text-rose-400 sm:inline" data-id="element-226" data-mp="lus9i0u65en1">
                  {hours}:{minutes}:{seconds}
                </span>
              </p>
            </div>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: 'MegaPack Reto 30 Días Fit',
          value: 19990,
          currency: 'ARS'
        })} className="shrink-0 rounded-full bg-gold-500 px-5 py-3 font-display text-xs uppercase tracking-wide text-ink-950 transition-colors hover:bg-gold-400 sm:text-sm" data-id="element-227" data-mp="zs70ha02luh4">
              Quiero mi MegaPack
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}